import { clsx } from "clsx";
import type { ReactNode } from "react";

type TabsProps<T extends string> = {
  options: { value: T; label: ReactNode }[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
};

export function Tabs<T extends string>({
  options,
  value,
  onChange,
  className,
}: TabsProps<T>) {
  return (
    <div
      role="tablist"
      className={clsx(
        "inline-flex gap-1 rounded-md border border-border bg-surface-base p-1",
        className,
      )}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={clsx(
              "rounded px-3 py-1 text-xs font-medium transition",
              active
                ? "bg-accent text-foreground-inverse"
                : "text-foreground-secondary hover:bg-surface-subtle hover:text-foreground-primary",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
